(() => {
  const qs = (sel, ctx = document) => ctx.querySelector(sel);
  const qsa = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  const menuToggle = qs('[data-menu-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  const mobileNavOverlay = qs('[data-mobile-nav-overlay]');
  const menuClose = qs('[data-menu-close]');

  const setMobileMenuOpen = (open) => {
    if (!mobileNav || !menuToggle) return;
    mobileNav.classList.toggle('is-open', open);
    mobileNavOverlay?.classList.toggle('is-open', open);
    menuToggle.classList.toggle('is-active', open);
    menuToggle.setAttribute('aria-expanded', String(open));
    mobileNav.setAttribute('aria-hidden', String(!open));
    if (mobileNavOverlay) {
      mobileNavOverlay.hidden = !open;
      mobileNavOverlay.setAttribute('aria-hidden', String(!open));
    }
    document.body.classList.toggle('menu-open', open);
  };

  const closeMobileMenu = () => setMobileMenuOpen(false);

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      setMobileMenuOpen(!mobileNav.classList.contains('is-open'));
    });
    menuClose?.addEventListener('click', closeMobileMenu);
    mobileNavOverlay?.addEventListener('click', closeMobileMenu);
    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMobileMenu);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) closeMobileMenu();
    });
  }

  const overlay = qs('[data-cart-overlay]');
  const drawer = qs('[data-cart-drawer]');
  const openers = qsa('[data-cart-open]');
  const closers = qsa('[data-cart-close]');

  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay?.classList.add('is-open');
    document.body.classList.add('drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
  };

  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
  };

  openers.forEach((el) =>
    el.addEventListener('click', (e) => {
      if (el.dataset.cartOpen !== 'link') e.preventDefault();
      openCart();
    })
  );
  closers.forEach((el) => el.addEventListener('click', closeCart));
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  const formatMoney = (cents) => {
    try {
      return (cents / 100).toLocaleString('it-IT', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
      });
    } catch {
      return `€${(cents / 100).toFixed(2).replace('.', ',')}`;
    }
  };

  const updateCartCount = (count) => {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = String(count);
      el.hidden = count < 1;
      el.classList.add('is-pulse');
      setTimeout(() => el.classList.remove('is-pulse'), 450);
    });
  };

  const announceCart = (msg) => {
    const live = qs('[data-cart-live]');
    if (live) live.textContent = msg;
  };

  const renderPriceHtml = (variant) => {
    if (!variant) return '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      return `<span class="price price--sale"><s>${formatMoney(variant.compare_at_price)}</s> ${formatMoney(variant.price)}</span>`;
    }
    return `<span class="price">${formatMoney(variant.price)}</span>`;
  };

  const updatePriceDisplays = (variant) => {
    const html = renderPriceHtml(variant);
    qsa('[data-product-price], [data-buy-bar-price]').forEach((el) => {
      if (html) el.innerHTML = html;
    });
  };

  const renderDrawerItems = (cart) => {
    const body = qs('[data-cart-drawer-items]');
    const empty = qs('[data-cart-drawer-empty]');
    const footer = qs('[data-cart-drawer-footer]');
    const total = qs('[data-cart-drawer-total]');
    if (!body) return;

    if (!cart.items?.length) {
      body.innerHTML = '';
      empty?.removeAttribute('hidden');
      footer?.setAttribute('hidden', '');
      return;
    }

    empty?.setAttribute('hidden', '');
    footer?.removeAttribute('hidden');
    if (total) total.textContent = formatMoney(cart.total_price);

    body.innerHTML = cart.items
      .map((item) => {
        const variantLine =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="cart-item__variant">${item.variant_title}</div>`
            : '';
        const imgSrc = item.image || '';
        return `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__image" src="${imgSrc}" alt="${item.product_title}" width="80" height="80" loading="lazy">
        <div>
          <div class="cart-item__title">${item.product_title}</div>
          ${variantLine}
          <div class="cart-item__unit">${formatMoney(item.final_price)} · ${formatMoney(item.final_line_price)}</div>
          <div class="qty-field" style="margin-top:0.5rem">
            <button type="button" data-qty-change="-1" data-line-key="${item.key}" aria-label="Diminuisci">−</button>
            <input type="number" value="${item.quantity}" min="0" readonly aria-label="Quantità">
            <button type="button" data-qty-change="1" data-line-key="${item.key}" aria-label="Aumenta">+</button>
          </div>
        </div>
        <button type="button" class="icon-btn" data-remove-item="${item.key}" aria-label="Rimuovi" style="color:var(--color-primary)">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
      </div>`;
      })
      .join('');
  };

  const fetchCart = () =>
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        updateCartCount(cart.item_count);
        renderDrawerItems(cart);
        return cart;
      });

  const changeLine = (key, quantity) =>
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then((r) => r.json())
      .then((cart) => {
        updateCartCount(cart.item_count);
        renderDrawerItems(cart);
        return cart;
      });

  const addToCart = async ({ id, quantity = 1, open = true }) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }),
    });
    if (!res.ok) throw new Error('add_failed');
    await fetchCart();
    if (open) openCart();
    announceCart('Prodotto aggiunto al carrello');
  };

  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const row = qtyBtn.closest('.cart-item');
      const input = row?.querySelector('input');
      const key = qtyBtn.dataset.lineKey;
      const delta = Number(qtyBtn.dataset.qtyChange);
      const next = Math.max(0, Number(input?.value || 0) + delta);
      changeLine(key, next);
    }

    const removeBtn = e.target.closest('[data-remove-item]');
    if (removeBtn) changeLine(removeBtn.dataset.removeItem, 0);

    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      e.stopPropagation();
      const btn = quick;
      btn.classList.add('is-loading');
      addToCart({ id: btn.dataset.variantId, quantity: 1 })
        .then(() => {
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 900);
        })
        .catch(() => {})
        .finally(() => btn.classList.remove('is-loading'));
    }
  });

  const productForms = qsa('form[data-product-form]');
  productForms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const status = form.querySelector('[data-form-status]');
      const id = form.querySelector('input[name="id"]')?.value;
      const quantity = form.querySelector('input[name="quantity"]')?.value || 1;
      if (btn) btn.disabled = true;
      if (status) status.textContent = '';
      try {
        await addToCart({ id, quantity: Number(quantity), open: true });
        if (status) {
          status.className = 'form-status form-status--success';
          status.textContent = 'Aggiunto al carrello';
        }
      } catch {
        if (status) {
          status.className = 'form-status form-status--error';
          status.textContent = 'Impossibile aggiungere al carrello';
        }
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });

  qsa('[data-buy-now]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const form = btn.closest('form') || qs('form[data-product-form]');
      const id = form?.querySelector('input[name="id"]')?.value;
      const quantity = form?.querySelector('input[name="quantity"]')?.value || 1;
      btn.disabled = true;
      try {
        await addToCart({ id, quantity: Number(quantity), open: false });
        window.location.href = '/checkout';
      } catch {
        btn.disabled = false;
      }
    });
  });

  qsa('[data-qty-input]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const delta = Number(btn.dataset.delta);
        const next = Math.max(1, Number(input.value || 1) + delta);
        input.value = String(next);
      });
    });
  });

  // Gallery thumbs — swap full-resolution src + srcset
  const mainImg = qs('#ProductMainImage');

  const setMainImage = (src, srcset) => {
    if (!mainImg || !src) return;
    mainImg.src = src;
    if (srcset) {
      mainImg.srcset = srcset;
    } else {
      mainImg.removeAttribute('srcset');
    }
  };

  qsa('[data-thumb-src]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      setMainImage(thumb.dataset.thumbSrc, thumb.dataset.thumbSrcset);
      qsa('[data-thumb-src]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // Sticky buy bar
  const buyBar = qs('[data-buy-bar]');
  const productForm = qs('form[data-product-form]');
  if (buyBar && productForm) {
    const io = new IntersectionObserver(
      ([entry]) => {
        buyBar.hidden = entry.isIntersecting;
      },
      { threshold: 0.15 }
    );
    io.observe(productForm);
    qs('[data-buy-bar-add]')?.addEventListener('click', () => {
      productForm.requestSubmit();
    });
    qs('[data-buy-bar-now]')?.addEventListener('click', () => {
      qs('[data-buy-now]')?.click();
    });
  }

  // Reveal on scroll — gestito da luxury-animations.js (GSAP ScrollTrigger)

  // Variant pills + price sync
  const productJsonEl = qs('[data-product-json]');
  const variantInput = qs('form[data-product-form] input[name="id"]');
  let productData = null;
  if (productJsonEl) {
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch {
      productData = null;
    }
  }

  const optionSelects = qsa('form[data-product-form] select[name^="options"]');
  const variantPills = qsa('.variant-picker__option');

  const syncVariant = () => {
    if (!productData?.variants) return;
    const selected = optionSelects.map((s) => s.value);
    const match = productData.variants.find((v) =>
      selected.every((val, idx) => v[`option${idx + 1}`] === val)
    );
    if (!match) return;

    if (variantInput) variantInput.value = match.id;
    updatePriceDisplays(match);

    const btn = qs('form[data-product-form] [type="submit"]');
    const buyNow = qs('[data-buy-now]');
    const availability = qs('.product-info__availability');
    if (btn) {
      btn.disabled = !match.available;
      btn.textContent = match.available ? 'Aggiungi al carrello' : 'Esaurito';
    }
    if (buyNow) buyNow.disabled = !match.available;
    if (availability) {
      availability.hidden = match.available;
      availability.classList.toggle('product-info__availability--out', !match.available);
    }
    if (match.featured_image?.id) {
      const thumb = qs(`[data-media-id="${match.featured_image.id}"]`);
      if (thumb) {
        setMainImage(thumb.dataset.thumbSrc, thumb.dataset.thumbSrcset);
        qsa('[data-thumb-src]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    }

    variantPills.forEach((pill) => {
      const idx = Number(pill.dataset.optionIndex);
      const isSelected = pill.dataset.value === selected[idx];
      pill.classList.toggle('is-selected', isSelected);
      pill.setAttribute('aria-pressed', String(isSelected));
    });
  };

  variantPills.forEach((pill) => {
    pill.addEventListener('click', () => {
      const idx = Number(pill.dataset.optionIndex);
      const select = optionSelects[idx];
      if (!select) return;
      select.value = pill.dataset.value;
      syncVariant();
    });
  });

  optionSelects.forEach((s) => s.addEventListener('change', syncVariant));

  // Collection sort
  qs('[data-collection-sort]')?.addEventListener('change', (e) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    window.location.href = url.toString();
  });

  fetchCart().catch(() => {});

  const header = qs('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
